import React from 'react';
import config from 'react-native-ultimate-config';
import getTheme from '../10-parts';
import selectBasedOnThemeID from '../utils/selectBasedOnThemeID';
const ThemeContext = React.createContext({
    theme: getTheme(config.DEFAULT_THEME),
    dimensions: {
        device: {
            height: 0,
            width: 0,
        },
        viewPort: {
            height: 0,
            width: 0,
        },
        safeAreaInsets: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        breakpoint: {
            width: {
                sm: false,
                md: false,
                lg: false,
            },
            height: {
                sm: false,
                md: false,
                lg: false,
            },
        },
    },
    select: selectBasedOnThemeID(config.DEFAULT_THEME),
    deviceType: {
        isPhone: false,
        isTablet: false,
        isDesktop: false,
    },
    change(_newTheme) { },
});
export default ThemeContext;
